// ES2015/es6 interface

// This should be the only `import *` present in this file. For all others, please use named exports.
export * from './lib/types/types';
export {
    FirstResponderStatusDefaultMessagesEnum,
    MedicalProfessionalStatusDefaultMessagesEnum,
    VerificationStepsEnum,
} from './lib/types/runtimeTypes';

export { setRef, resetRefs } from './lib/refs/refs';
export { setFocus } from './lib/utils/browser/inputHelpers';

export { setOptions } from './options/options';

export {
    assertValidVerificationStepName,
    assertValidMockStepName,
    assertValidSegmentName,
    assertValidLocale,
    assertValidHtmlElement,
    assertValidProgramId,
    assertValidFieldId,
    assertValidTryAgainStep,
    assertValidHook,
    assertValidHookName,
    assertValidFunction,
    assertValidTrackingId,
    assertValidDatabaseId,
} from './lib/types/assertions';

export {
    validateFieldById,
    validateMetadata,
    ensureMaxMetadataKeyValueLengths,
    getFieldValidationErrors,
    isFormFilled,
    isFormErrored,
    isValidUsPostalCode,
} from './lib/validators/validators';

export {
    overrideValidator,
    getOverridenValidator,
    resetOverriddenValidators,
} from './lib/validators/validatorOverride';

export {
    setViewModel,
    resetViewModel,
} from './lib/VerificationService/ViewModel';

export {
    setCustomValidator,
    getCustomValidator,
    getCustomValidatorFields,
    resetCustomValidators,
} from './lib/validators/customValidators';

export {
    addHook,
    getHook,
} from './lib/hooks/hooks';

export {
    getMetadata,
    setMetadata,
} from './lib/metadata/metadata';

export {
    getFaqLink,
    getCompanyName,
} from './lib/ProgramTheme/programThemeGetters';

export {
    getConfiguredCountries,
    getAvailableLocales,
} from './lib/ProgramTheme/programThemeGetters';

export { conversion } from './lib/conversion/conversion';

export { overrideComponent } from './lib/componentOverride/componentOverride';
export { logger } from './lib/utils/logger/logger';

export {
    addFiles,
    removeFile,
    removeAllFiles,
} from './lib/ServerApi/VerificationRequestSetters';

export { VerificationForm } from './components/VerificationForm/VerificationFormComponent';

export { AddressComponent } from './components/FormFields/Address/AddressComponent';
export { BirthDateComponent } from './components/FormFields/BirthDate/BirthDateComponent';
export { BranchOfServiceComponent } from './components/FormFields/BranchOfService/BranchOfServiceComponent';
export { CityComponent } from './components/FormFields/City/City';
export { ChangeLocaleComponent } from './components/FormFields/ChangeLocale/ChangeLocaleComponent';
export { CollegeNameComponent } from './components/FormFields/CollegeName/CollegeNameComponent';
export { CompanyComponent } from './components/FormFields/Company/CompanyComponent';
export { CountryComponent } from './components/FormFields/Country/CountryComponent';
export { DischargeDateComponent } from './components/FormFields/DischargeDate/DischargeDateComponent';
export { EmailComponent } from './components/FormFields/Email/EmailComponent';
export { PhoneNumberComponent } from './components/FormFields/PhoneNumber/PhoneNumberComponent';
export { FirstNameComponent } from './components/FormFields/FirstName/FirstNameComponent';
export { LastNameComponent } from './components/FormFields/LastName/LastNameComponent';
export { LogoComponent } from './components/LogoComponent/LogoComponent';
export { MarketConsentWrapperComponent as MarketConsentWrapper } from './components/FormFields/MarketConsentWrapper/MarketConsentWrapperComponent';
export { OptInComponent } from './components/FormFields/OptIn/OptInComponent';
export { PostalCodeComponent } from './components/FormFields/PostalCode/PostalCodeComponent';
export { StateComponent } from './components/FormFields/State/State';

export { TryAgainButtonComponent } from './components/TryAgainButtonComponent';
export { FormFooterComponent } from './components/FormFooter/FormFooterComponent';
export { HowDoesVerifyingWorkComponent } from './components/HowDoesVerifyingWork/HowDoesVerifyingWorkComponent';

export { TeacherSchoolComponent } from './components/FormFields/TeacherSchool/TeacherSchoolComponent';
export { FirstResponderOrganizationComponent } from './components/FormFields/FirstResponderOrganization/FirstResponderOrganizationComponent';
export { MedicalProfessionalOrganizationComponent } from './components/FormFields/MedicalProfessionalOrganization/MedicalProfessionalOrganizationComponent';

export { MilitaryStatusComponent } from './components/FormFields/MilitaryStatus/MilitaryStatusComponent';
export { FirstResponderStatusComponent } from './components/FormFields/FirstResponderStatus/FirstResponderStatusComponent';
export { MedicalStatusComponent } from './components/FormFields/MedicalStatus/MedicalStatusComponent';

export { hasFailedInstantMatch } from './lib/VerificationService/VerificationServiceHelpers';

export {
    handleEmailOnKeyDown,
    submitForm,
    updateFieldValidationErrorsByFieldId,
    updateViewModelOrganization,
    getAvailableCountryChoices,
    getAvailableLocaleChoices,
    handleCountryOnKeyDown,
    getDefaultCountryChoice,
} from './lib/utils/stepComponentHelpers/stepComponentHelpers';

